import Vue from "vue";
import VueRouter from "vue-router";

const publicPath = "";

export const paths = {
  root: publicPath + "/",
  index: publicPath + "/",
  light: publicPath + "/light/",
  inSwitchLED: publicPath + "/in-switch-led/",
  keyboard: publicPath + "/keyboard/",
  keyboardNew: publicPath + "/keyboard/cyberboard/",
  keyboardHatsu: publicPath + "/keyboard/hatsu/",
  keyboardAlice: publicPath + "/keyboard/am-afa/",
  keyboardAliceOld: publicPath + "/keyboard/alice/",
  inSwitchLEDAlice: publicPath + "/in-switch-led/am-afa/",
  keyboard65Fluffy: publicPath + "/keyboard/petbrick-65/",
  inSwitchLED65Fluffy: publicPath + "/in-switch-led/petbrick-65/",
  index65GameBoy: publicPath + "/index/am-rgb-65/",
  keyboard65GameBoy: publicPath + "/keyboard/am-rgb-65/",
  inSwitchLED65GameBoy: publicPath + "/in-switch-led/am-rgb-65/",
  light65GameBoy: publicPath + "/light/am-rgb-65/",
  keyboard65Less: publicPath + "/keyboard/65-less/",
  inSwitchLED65Less: publicPath + "/in-switch-led/65-less/",
  keyboard65LessSplit: publicPath + "/keyboard/65-less-split/",
  inSwitchLED65LessSplit: publicPath + "/in-switch-led/65-less-split/",
  keyboard75: publicPath + "/keyboard/black-diamond-75/",
  inSwitchLED75: publicPath + "/in-switch-led/black-diamond-75/",
  keyboard80: publicPath + "/keyboard/am-relic-80/",
  inSwitchLED80: publicPath + "/in-switch-led/am-relic-80/",
  library: publicPath + "/library/",
  profile: publicPath + "/profile/",
  publish: publicPath + "/publish/",
  led: publicPath + "/led/:id/",
  ledEdit: publicPath + "/led-edit/:id/",
  user: publicPath + "/user/:uuid/",
  welcome: publicPath + "/welcome/",
  deviceList: publicPath + "/device-list/",
  dongleList: publicPath + "/dongle-list/",
  dongle: publicPath + "/dongle/",
  settings: publicPath + "/settings/",
  firmware: publicPath + "/firmware/",
  laboratory: publicPath + "/laboratory/",
  mouse: publicPath + "/mouse/",
  mouseConnect: publicPath + "/mouse-connect/",
  mouseFirmware: publicPath + "/mouse-firmware/",
  dongleMouse: publicPath + "/dongle-mouse/",
  dongleMouseFirmware: publicPath + "/dongle-mouse-firmware/",
  dongleMouseDongleFirmware: publicPath + "/dongle-mouse-dongle-firmware/",
  error404: publicPath + "/404/",
  magnetic: publicPath + "/magnetic/",
};

const constantRoutes = [
  {
    path: paths.root,
    component: () => import("./layouts/MainLayout.vue"),
    children: [
      {
        path: paths.index,
        name: "Index",
        component: () => import("./views/Index.vue"),
      },
      {
        path: paths.light,
        name: "Light",
        component: () => import("./views/Cyberboard/Light.vue"),
      },
      {
        path: paths.inSwitchLED,
        name: "InSwitchLED",
        component: () => import("./views/Cyberboard/InSwitchLED.vue"),
      },
      {
        path: paths.keyboard,
        name: "Keyboard",
        component: () => import("./views/Cyberboard/Keyboard.vue"),
      },
      {
        path: paths.keyboardNew,
        name: "Keyboard New",
        component: () => import("./views/CyberboardNew/KeyboardNew.vue"),
      },
      {
        path: paths.keyboardHatsu,
        name: "Keyboard Hatsu",
        component: () => import("./views/Hatsu/KeyboardHatsu.vue"),
        // meta: { requiresAuth: true },
      },
      {
        path: paths.keyboardAlice,
        name: "Keyboard Alice",
        component: () => import("./views/Alice/KeyboardAlice.vue"),
        // meta: { requiresAuth: true },
      },
      {
        path: paths.keyboardAliceOld,
        redirect: paths.keyboardAlice,
        hidden: true,
      },
      {
        path: paths.inSwitchLEDAlice,
        name: "In Switch LED Alice",
        component: () => import("./views/Alice/InSwitchLEDAlice.vue"),
        // meta: { requiresAuth: true },
      },
      {
        path: paths.keyboard65Fluffy,
        name: "Keyboard PetBrick 65",
        component: () => import("./views/65Fluffy/Keyboard65Fluffy.vue"),
        // meta: { requiresAuth: true },
      },
      {
        path: paths.inSwitchLED65Fluffy,
        name: "In Switch LED PetBrick 65",
        component: () => import("./views/65Fluffy/InSwitchLED65Fluffy.vue"),
        // meta: { requiresAuth: true },
      },
      {
        path: paths.index65GameBoy,
        name: "Keyboard AM RGB 65",
        component: () => import("./views/65GameBoy/Index65GameBoy.vue"),
        // meta: { requiresAuth: true },
      },
      {
        path: paths.keyboard65GameBoy,
        name: "Keyboard AM RGB 65",
        component: () => import("./views/65GameBoy/Keyboard65GameBoy.vue"),
        // meta: { requiresAuth: true },
      },
      {
        path: paths.inSwitchLED65GameBoy,
        name: "In Switch LED AM RGB 65",
        component: () => import("./views/65GameBoy/InSwitchLED65GameBoy.vue"),
        // meta: { requiresAuth: true },
      },
      {
        path: paths.light65GameBoy,
        name: "Light AM RGB 65",
        component: () => import("./views/65GameBoy/Light65GameBoy.vue"),
        // meta: { requiresAuth: true },
      },
      {
        path: paths.keyboard65Less,
        name: "Keyboard 65 Less",
        component: () => import("./views/65Less/Keyboard65Less.vue"),
        // meta: { requiresAuth: true },
      },
      {
        path: paths.inSwitchLED65Less,
        name: "In Switch LED 65 Less",
        component: () => import("./views/65Less/InSwitchLED65Less.vue"),
        // meta: { requiresAuth: true },
      },
      {
        path: paths.keyboard65LessSplit,
        name: "Keyboard 65 Less Split",
        component: () => import("./views/65LessSplit/Keyboard65LessSplit.vue"),
        // meta: { requiresAuth: true },
      },
      {
        path: paths.inSwitchLED65LessSplit,
        name: "In Switch LED 65 Less Split",
        component: () =>
          import("./views/65LessSplit/InSwitchLED65LessSplit.vue"),
        // meta: { requiresAuth: true },
      },
      {
        path: paths.keyboard75,
        name: "Keyboard 75",
        component: () => import("./views/75/Keyboard75.vue"),
        // meta: { requiresAuth: true },
      },
      {
        path: paths.inSwitchLED75,
        name: "In Switch LED 75",
        component: () => import("./views/75/InSwitchLED75.vue"),
        // meta: { requiresAuth: true },
      },
      {
        path: paths.keyboard80,
        name: "Keyboard 80",
        component: () => import("./views/80/Keyboard80.vue"),
        // meta: { requiresAuth: true },
      },
      {
        path: paths.inSwitchLED80,
        name: "In Switch LED 80",
        component: () => import("./views/80/InSwitchLED80.vue"),
        // meta: { requiresAuth: true },
      },
      {
        path: paths.library,
        name: "Library",
        component: () => import("./views/Library.vue"),
      },
      {
        path: paths.mouse,
        name: "Mouse",
        component: () => import("./views/Mouse/Mouse.vue"),
      },
      {
        path: paths.mouseConnect,
        name: "Connect",
        component: () => import("./views/Mouse/Connect.vue"),
      },
      {
        path: paths.mouseFirmware,
        name: "Firmware",
        component: () => import("./views/Mouse/Firmware.vue"),
      },
      {
        path: paths.dongleMouse,
        name: "Mouse",
        component: () => import("./views/Mouse/Mouse.vue"),
      },
      {
        path: paths.dongleMouseFirmware,
        name: "Firmware",
        component: () => import("./views/Mouse/Firmware.vue"),
      },
      {
        path: paths.dongleMouseDongleFirmware,
        name: "Dongle Firmware",
        component: () => import("./views/Mouse/DongleFirmware.vue"),
      },
      {
        path: paths.magnetic,
        name: "Keyboard",
        component: () => import("./views/Magnetic/Keyboard.vue"),
      },
      {
        path: paths.user,
        name: "User",
        component: () => import("./views/User.vue"),
      },
      {
        path: paths.publish,
        name: "Publish",
        component: () => import("./views/Publish.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: paths.ledEdit,
        name: "LED Publish",
        component: () => import("./views/Publish.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: paths.led,
        name: "LED",
        component: () => import("./views/LED.vue"),
      },
      {
        path: paths.welcome,
        name: "Welcome",
        component: () => import("./views/Welcome.vue"),
      },
      {
        path: paths.deviceList,
        name: "Device List",
        component: () => import("./views/DeviceList.vue"),
      },
      {
        path: paths.dongleList,
        name: "Dongle List",
        component: () => import("./views/DongleList.vue"),
      },
      {
        path: paths.dongle,
        name: "Dongle",
        component: () => import("./views/Dongle.vue"),
      },
      {
        path: paths.settings,
        name: "Loader",
        component: () => import("./views/Settings.vue"),
      },
      {
        path: paths.firmware,
        name: "Firmware",
        component: () => import("./views/Firmware.vue"),
      },
      {
        path: paths.laboratory,
        name: "Laboratory",
        component: () => import("./views/Laboratory.vue"),
      },
    ],
  },
  // {
  //   path: paths.error404,
  //   component: () => import('./views/Error404'),
  //   meta: {
  //     title: '',
  //   },
  // },
  // 404 page must be placed at the end !!!
  {
    path: "*",
    redirect: paths.error404,
    hidden: true,
  },
];

const router = new VueRouter({
  mode: "history", // require service support
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: constantRoutes,
});

const VueRouterPush = VueRouter.prototype.push;
const VueRouterReplace = VueRouter.prototype.replace;

VueRouter.prototype.push = function push(location) {
  return VueRouterPush.call(this, location).catch((err) => err);
};
VueRouter.prototype.replace = function replace(location) {
  return VueRouterReplace.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);
Vue.prototype.$paths = paths;

export default router;
